import * as React from 'react';
import { Row, Col, DatePicker, Divider, Button, Select } from 'antd';
import moment from 'moment';
import { TSInput } from '../common/TSInput';
import { ExpenseEntryDetailInput } from './constants';
import { ExpenseEntryFormData } from './constants';
import { Bussiness, CompanyNodeEdge } from '../master/Company/constants';
import { ExpenseDropdown } from '../master/Expense/ExpenseDropdown';
import { ExpenseNode } from '../../schema';

export const ExpenseEntryForm: React.FunctionComponent<Props> = (props) => {
  return (
    <Row>
      <Col span={8}>
        <DatePicker
          value={
            props.value.date
              ? moment(props.value.date)
              : moment(moment().format('YYYY-MM-DD'))
          }
          onChange={(e) =>
            props.onChange({
              target: {
                name: 'date',
                value: e && moment(e).format('YYYY-MM-DD'),
              },
            })
          }
          placeholder="Date"
          format="DD-MM-YYYY"
          style={{ margin: '5px 0', width: '100%' }}
        />
      </Col>
      {/* <Col span={16}>
        <TSInput
          error={''}
          key="id"
          name="branchId"
          value={props.currentBusiness.name}
          addonBefore="Branch"
        />
      </Col> */}
      <Divider />
      <h4>Expense Head</h4>
      <Row>
        <Col span={1}>Sl. No.</Col>
        <Col span={4}>Expense</Col>
        <Col span={4}>Paid To</Col>
        <Col span={4}>Payment Mode</Col>
        <Col span={4}>Amount</Col>
        <Col span={4}>Remarks</Col>
        <Col span={2}>Remove</Col>
        <Col span={1}>Add</Col>
        <Divider />
      </Row>
      {props.value.expenseDetails.map((expense, index) => (
        <div key={'expenses' + index}>
          <Row>
            <Col span={1}>{index + 1}.</Col>
            <Col span={4}>
              <ExpenseDropdown
                onSelect={(e, f) => {
                  props.expenseObjChangeHandler(
                    (f as any).props.expense.node,
                    index,
                  );
                  props.expenseChangeHandler(
                    { target: { name: 'expenseId', value: String(e) } },
                    index,
                  );
                }}
                allowClear
                companyId={props.company.id || ''}
                value={expense.expenseId || ''}
              />
            </Col>
            <Col span={4}>
              <TSInput
                error=""
                type="text"
                value={expense.paidTo || ''}
                name="paidTo"
                placeholder="Paid To"
                required
                onChange={(e) => props.expenseChangeHandler(e, index)}
              />
            </Col>
            <Col span={4}>
              <Select
                defaultValue="Cash"
                style={{ width: '100%' }}
                value={expense.paymentMode || 'Cash'}
                onChange={(value) =>
                  props.paymentModeChangeHandler(
                    {
                      target: {
                        name: 'paymentMode',
                        value: value.toString(),
                      },
                    },
                    index,
                  )
                }
              >
                <Select.Option value="Cash">Cash</Select.Option>
                <Select.Option value="Bank">Bank</Select.Option>
                <Select.Option value="UPI">UPI</Select.Option>
                <Select.Option value="Cheque">Cheque</Select.Option>
                <Select.Option value="Card">Card</Select.Option>
              </Select>
            </Col>
            <Col span={4}>
              <TSInput
                error=""
                type="number"
                value={expense.amount || 0}
                name="amount"
                placeholder="Amount"
                required
                onChange={(e) => props.expenseChangeHandler(e, index)}
              />
            </Col>
            <Col span={4}>
              <TSInput
                error=""
                type="text"
                value={expense.remarks || ''}
                name="remarks"
                placeholder="Remarks"
                onChange={(e) => props.expenseChangeHandler(e, index)}
              />
            </Col>
            <Col span={2}>
              <Button
                type="primary"
                shape="circle"
                icon="minus"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  props.updateExpenseRows('-', index);
                }}
                disabled={props.value.expenseDetails.length === 1}
              />
            </Col>
            <Col span={1}>
              <Button
                type="primary"
                shape="circle"
                icon="plus"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  props.updateExpenseRows('+', index);
                }}
                disabled={
                  props.value.expenseDetails.length >= 10 ? true : false
                }
              />
            </Col>
          </Row>
        </div>
      ))}
    </Row>
  );
};

interface Props {
  value: ExpenseEntryFormData<ExpenseEntryDetailInput[]>;
  onChange: (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | { target: { name: string; value: string | number | boolean | null } },
  ) => void;
  company: CompanyNodeEdge;
  currentBusiness: Bussiness;
  expenseChangeHandler: (
    e: { target: { name: string; value: string | number } },
    index: number,
  ) => void;
  updateExpenseRows: (type: string, index: number) => void;
  expenseObjChangeHandler: (value: ExpenseNode, index: number) => void;
  expenseObjList: ExpenseNode[];
  paymentModeChangeHandler: (
    e: { target: { name: string; value: string } },
    index: number,
  ) => void;
}
